/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PayrollViewerControllerImportPayroll200ResponseDataInnerWarningsInner { 
    code?: PayrollViewerControllerImportPayroll200ResponseDataInnerWarningsInner.CodeEnum;
    detail?: string;
}
export namespace PayrollViewerControllerImportPayroll200ResponseDataInnerWarningsInner {
    export type CodeEnum = 'UNMAPPED_CONCEPT' | 'EMPLOYEE_WITHOUT_FILE' | 'NSS_MISMATCH' | 'INCOMPLETE_PERIOD' | 'TERMINATED_IN_PERIOD' | 'SPECIAL_RUN_EXCLUDED';
    export const CodeEnum = {
        UnmappedConcept: 'UNMAPPED_CONCEPT' as CodeEnum,
        EmployeeWithoutFile: 'EMPLOYEE_WITHOUT_FILE' as CodeEnum,
        NssMismatch: 'NSS_MISMATCH' as CodeEnum,
        IncompletePeriod: 'INCOMPLETE_PERIOD' as CodeEnum,
        TerminatedInPeriod: 'TERMINATED_IN_PERIOD' as CodeEnum,
        SpecialRunExcluded: 'SPECIAL_RUN_EXCLUDED' as CodeEnum
    };
}


